var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImageEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.849,
    height: 38.852,
    viewBox: "0 0 38.849 38.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11714",
    "data-name": "Path 11714",
    d: "M143.742,2.006a5.96,5.96,0,0,0-8.429,0L111.686,25.634a1.324,1.324,0,0,0-.34.583l-3.107,11.218a1.324,1.324,0,0,0,1.63,1.63l11.218-3.108a1.324,1.324,0,0,0,.583-.34L145.3,11.989a5.966,5.966,0,0,0,0-8.429ZM114.571,26.5,133.909,7.157l6.237,6.237L120.807,32.732ZM113.325,29l4.983,4.983-6.892,1.91Zm30.1-18.879-1.4,1.4-6.237-6.237,1.405-1.4a3.311,3.311,0,0,1,4.682,0l1.555,1.554A3.316,3.316,0,0,1,143.423,10.116Zm0,0",
    transform: "translate(-108.19 -0.261)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageEditIcon);
export default __webpack_public_path__ + "static/media/profileImageEdit_icon.b99e81c29f8b3c4cca9aab6fdb19b64a.svg";
export { ForwardRef as ReactComponent };